/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTIcon } from '../../../helpers'
import { useLayout } from '../../core'
import { HeaderToolbar } from './HeaderToolbar'
import uztripLogo from "../../../assets/media/mainLogo.png"
import { useEffect, useState } from 'react'
import { fetchData } from '../../../../reusable'
import { HeaderNotificationsMenu } from '../../../partials'

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { aside } = config

  const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
    toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px'

  const [unreadNotificationCount, setUnreadNotificationCount] = useState('') as any
  const [showNotifications, setShowNotifications] = useState(0) // 0 means hidden, 1 means show

  const unreadNotificationCountApiCall = async () => {

    try {
      const tmp2 = sessionStorage.getItem('admin');
      let adminId;

      if (tmp2) {
        const adminData = JSON.parse(tmp2);
        adminId = adminData.adminId;
      }

      if (!adminId) throw new Error("Admin ID not found in session storage");

      const param = { adminId };
      const response: any = await fetchData('admin/unreadnotification', param);

      if (response.status == '200') {
        setUnreadNotificationCount(response.data.count);
      } else {
        console.error("Error fetching unread notifications:", response);
      }
    } catch (error) {
      console.error("Error in unreadNotificationCountApiCall:", error);
    }
  };


  useEffect(() => {
    if (showNotifications == 0) {
      unreadNotificationCountApiCall()
    }
  }, [showNotifications])

  return (
    <>
      <div
        id='kt_header'
        className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
        {...attributes.headerMenu}
      >
        {/* begin::Brand */}
        <div className='header-brand'>
          {/* begin::Logo */}
          <Link to='/'>
            <img
              alt='Logo'
              src={uztripLogo}
              className='h-50px h-lg-50px'
            />
          </Link>
          {/* end::Logo */}

          {aside.minimize && (
            <div
              id='kt_aside_toggle'
              className='btn btn-icon w-auto px-0 btn-active-color-success aside-minimize'
              data-kt-toggle='true'
              data-kt-toggle-state='active'
              data-kt-toggle-target='body'
              data-kt-toggle-name='aside-minimize'
            >
              <KTIcon iconName='exit-left' className='fs-1 me-n1 minimize-default' />
              <KTIcon iconName='entrance-left' className='fs-1 minimize-active' />
            </div>
          )}

          {/* begin::Aside toggle */}
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-30px h-30px'
              id='kt_aside_mobile_toggle'
            >
              <KTIcon iconName='abstract-14' className='fs-1' />
            </div>
            <div className='toolbar d-flex align-items-stretch'>
              {/* begin::Toolbar container */}

              <div className='d-flex justify-content-start mx-1 align-items-center'>
                <div
                  className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
                  style={{ position: 'relative' }}
                >
                  <div
                    className={clsx(
                      'btn btn-icon btn-active-light-primary btn-custom',
                      toolbarButtonHeightClass
                    )}
                    data-kt-menu-trigger='click'
                    data-kt-menu-attach='parent'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-flip='bottom'
                    onClick={() => {
                      setUnreadNotificationCount(0)
                      setShowNotifications((prev) => (prev === 0 ? 1 : 0))
                    }}
                  >
                    <i className='ki-solid ki-notification-on fs-1 text-dark'></i>
                  </div>
                  <HeaderNotificationsMenu show={showNotifications} />

                  <span
                    style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '-12px',
                      backgroundColor: '#d9534f',
                      color: '#fff',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      borderRadius: '50%',
                      minWidth: '20px', // Ensures minimum size
                      padding: '2px 6px', // Dynamic padding for larger text
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                      whiteSpace: 'nowrap', // Prevent wrapping
                      textOverflow: 'ellipsis', // Add ellipsis for overflow
                      overflow: 'hidden',
                    }}
                  >
                    {unreadNotificationCount >= 99 ? '99' : unreadNotificationCount}
                    {/* 99 */}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* end::Aside toggle */}
        </div>
        {/* end::Brand */}
        <HeaderToolbar />
      </div>
    </>
  )
}
